import { useQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';
import { LoginFrame } from '@/components/customisation/login-frame';
import { PreviewBanner } from '@/components/customisation/preview-banner';
import { setDocumentTitle } from '@/lib/customisation/apply';
import { displayName } from '@/lib/customisation/logos';
import { useSite } from '@/lib/customisation/site';
import { sessionQuery } from '@/lib/session';
import { useTheme } from '@/lib/theme';

export const Route = createFileRoute('/_guest')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery);
    if (session.authenticated) throw redirect({ to: '/' });
  },
  component: GuestLayout,
});

/**
 * Sign-in, registration and password pages share the branded login frame; each page is
 * only the form inside it. The frame is part of the customer panel, so custom CSS applies.
 */
function GuestLayout() {
  const { data } = useQuery(sessionQuery);
  const site = useSite();
  const { theme } = useTheme();
  const panelName = data?.panel.name ?? 'Hearth';

  useEffect(() => {
    setDocumentTitle(displayName(site, panelName));
  }, [site, panelName]);

  return (
    <div className="hearth-custom flex min-h-dvh flex-col">
      <PreviewBanner signedIn={false} />
      <LoginFrame site={site} panelName={panelName} scheme={theme} className="flex-1">
        <Outlet />
      </LoginFrame>
    </div>
  );
}
